import { render } from "./UsersListDownload.vue?vue&type=template&id=6c0bf162&scoped=true"
import script from "./UsersListDownload.vue?vue&type=script&lang=js"
export * from "./UsersListDownload.vue?vue&type=script&lang=js"

import "./UsersListDownload.vue?vue&type=style&index=0&id=6c0bf162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0bf162"]])

export default __exports__